






































import { BookCommentComponents } from '../comment/components'
import { bookModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: BookCommentComponents,
  },
  () =>
    class {
      bookModel = bookModelProvider.inject()

      handleMoreClick = () => {
        navigateTo('BookCommentIndex', {
          martId: this.bookModel.value.martId,
        })
      }
    },
)
